import { PayloadAction } from '@reduxjs/toolkit';
import { ENUM__redux_action } from '../_base/ENUM__redux_action';
import { StateGenerationPrice } from './state_generation_price';

export const local_generation_price_delete_generation_price_by_diffusion_model_id = (payload: string[]): PayloadAction<string[]> => ({
  type: ENUM__redux_action.GENERATION_PRICE_DELETE_GENERATION_PRICE_BY_DIFFUSION_MODEL_ID,
  payload,
});

export const init_local_generation_price_delete_generation_price_by_diffusion_model_id = (state: StateGenerationPrice, action: PayloadAction<string[]>) => {
  let diffusion_models_ids_set = action.payload;

  if (diffusion_models_ids_set.is_empty()) return;

  for (let price_data of Array.from(state.generation_prices_by_hashes_map.values())) {
    if (!diffusion_models_ids_set.includes(price_data.diffusion_model_id)) continue; //no need to delete

    state.generation_prices_by_hashes_map.delete(price_data.hash);
  }

  //refresh map to trigger re-render
  state.generation_prices_by_hashes_map = new Map(state.generation_prices_by_hashes_map);
};
